import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'layout',
    label: 'Layout',
    type: types.OBJECT,
    children: [
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT,
      },
      {
        key: 'maxWidth',
        label: 'Max Width',
        type: types.TEXT,
      },
      {
        key: 'margin',
        label: 'Margin',
        type: types.TEXT,
      },
      {
        key: 'padding',
        label: 'Padding',
        type: types.TEXT,
      },
      // {
      //   key: 'titleAlignment',
      //   label: 'Title Alignment',
      //   type: types.ENUM,
      //   options: ['left', 'center', 'right'],
      // },
      {
        key: 'titlePadding',
        label: 'Title Padding',
        type: types.TEXT,
      },
      {
        key: 'descriptionPadding',
        label: 'Description Padding',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'images',
    label: 'Images',
    type: types.ARRAY,
    options: false,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT
      },
      {
        key: 'url',
        label: 'Image URL',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT
      },
    ]
  },
  {
    key: 'play',
    label: 'Play',
    type: types.OBJECT,
    children: [
      {
        key: 'autoplay',
        label: 'Autoplay',
        type: types.BOOLEAN
      },
      {
        key: 'autoplaySpeed',
        label: 'Autoplay Speed (in seconds)',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  layout: {
    width: '80%',
    margin: '0 auto',
    titlePadding: '0 0 48px 15%',
  },
  images: [
    { title: 'Title 1', subtitle: 'Subtitle 1', url: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/w-h-b0-q90-c0-8-default.jpg', description: 'Description 1 Description 1' },
    { title: 'Title 2', subtitle: 'Subtitle 2', url: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/_C3A5148-default.jpg', description: 'Description 2 Description 2' },
    { title: 'Title 3', subtitle: 'Subtitle 3', url: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/2880-Burj-default.jpg', description: 'Description 3 Description 3' },
    { title: 'Title 4', subtitle: 'Subtitle 4', url: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/w-h-b0-q90-c0-8-default.jpg', description: 'Description 4 Description 4' },
    { title: 'Title 5', subtitle: 'Subtitle 5', url: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/_C3A5148-default.jpg', description: 'Description 5 Description 5' },
    { title: 'Title 6', subtitle: 'Subtitle 6', url: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/2880-Burj-default.jpg', description: 'Description 6 Description 6' }
  ],
  play: {
    autoplay: true,
    autoplaySpeed: 5
  }
};

export default {
  title: 'Image Carousel',
  id: 'ImageCarousel',
  propsSchema,
  defaultProps
};
